import { useMutation } from '@tanstack/react-query';
import { customFetchV2 } from '../services/custom-fetch-v2';

interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

interface ChangePasswordResponse {
  success: boolean;
}

/**
 * API call to change a users password.
 */
const changePassword =
  async (request: ChangePasswordRequest): Promise<ChangePasswordResponse | null> => {
    const response = await customFetchV2<ChangePasswordResponse>('/sessions/me/change-password', {
      method: 'POST',
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error('Unable to update user phone');
    }

    return response.data;
  };

const useChangePasswordMutation = () => {
  return useMutation({
    mutationFn: changePassword,
    onSuccess: () => {
      // TODO: Would make sense to invalidate related queries in here.. just need
      // to get hold of device ID and device profile ID
    },
  });
};

/** Exports */
export { useChangePasswordMutation };

export type {
  ChangePasswordRequest,
  ChangePasswordResponse,
};
